import EventGenerateDone from '@/screens/EventGenerateDone';

export default function PrivateEventGenerateDoneRoute() {
  return <EventGenerateDone />;
}
